import { Autocomplete, Button, InputAdornment, Stack, TextField } from "@mui/material";
import Iconify from "../../../components/Iconify";
import { useLocales } from "../../../locales";
import * as React from "react";
import { useMemo } from "react";

export default function CommentsListTableToolbar({
                                                     filters,
                                                     onFilterChange,
                                                     onFilterDepartureTimeChange,
                                                     onOperatorChange,
                                                     onResetFilter,
                                                     onSearch,
                                                     tripTimes,
                                                     operatorsBE,
                                                 }) {
    const { translate } = useLocales();

    const uniqueTripTimes = useMemo(() => {
        if (!tripTimes) return [];
        const map = new Map();
        tripTimes.forEach(({ id, combinedTime }) => {
            if (!map.has(combinedTime)) {
                map.set(combinedTime, { combinedTime, id });
            }
        });
        return Array.from(map.values());
    }, [tripTimes]);

    const selectedDepartureTime = uniqueTripTimes.find(time => time.id === filters.departureTime) || null;
    const selectedOperator = operatorsBE?.length > 0 ? operatorsBE?.find(op => op.id === filters.operatorId) : null;

    return (
        <Stack
            spacing={2}
            alignItems="center"
            direction={{
                xs: 'column',
                sm: 'row',
            }}
            sx={{px: 2.5, py: 3}}
        >
            <TextField
                fullWidth
                size={"small"}
                value={filters.comment}
                onChange={onFilterChange}
                name="comment"
                placeholder={translate("comment")}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Iconify icon="eva:search-fill" sx={{color: 'text.disabled'}}/>
                        </InputAdornment>
                    ),
                }}
            />
            <TextField
                fullWidth
                size={"small"}
                value={filters.lineName}
                name="lineName"
                onChange={onFilterChange}
                placeholder="Linija"
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Iconify icon="eva:search-fill" sx={{color: 'text.disabled'}}/>
                        </InputAdornment>
                    ),
                }}
            />

            <Autocomplete
                fullWidth
                options={uniqueTripTimes || []}
                getOptionLabel={(option) => option.combinedTime?.slice(0, -3) || ""}
                value={selectedDepartureTime}
                onChange={(event, newValue) => onFilterDepartureTimeChange(newValue?.id || '')}
                size="small"
                renderInput={(params) => <TextField {...params} placeholder={translate("departureTime")} />}
            />

            <Autocomplete
                fullWidth
                options={operatorsBE || []}
                getOptionLabel={(option) => option?.name || ""}
                value={selectedOperator}
                onChange={(event, newValue) => onOperatorChange(newValue || '')}
                size="small"
                renderInput={(params) => <TextField {...params} placeholder={translate("carrier")} />}
            />

            <Button
                color="error"
                variant="outlined"
                sx={{ flexShrink: 0 }}
                onClick={onResetFilter}
                startIcon={<Iconify icon="eva:trash-2-outline" />}
            >
                {translate("clear")}
            </Button>
            <Button
                color="primary"
                variant="contained"
                sx={{ flexShrink: 0 }}
                onClick={onSearch}
                startIcon={<Iconify icon="material-symbols:search" />}
            >
                {translate("search")}
            </Button>

        </Stack>
    );
}
